<template>
  <b-container fluid>
    <b-row class="mb-3 mt-6">
      <b-col>
        <h4>Elementy szkolenia</h4>
        <p class="text-color-base">Przeciągnij i upuść element aby dostosować szkolenie</p>
      </b-col>
    </b-row>
    <b-row>
      <!-- group 1 -->
      <b-col
        md="6"
        cols="12"
      >
        <h6 class="my-4">
         Elementy przypisane do szkolenia szkolenia
        </h6>
        <!-- draggable -->
        <draggable
          :list="attachedTrainingElements"
          tag="ul"
          group="trainingElements"
          class="list-group dragArea elements-area"
          @change="handleChange"
        >
          <b-list-group-item
            v-for="(a, index) in attachedTrainingElements"
            :key="index"
            tag="li"
          >
            <b-card-text class="mb-0 font-weight-bold move-cursor">{{ a.name }} <span class="badge badge-info">{{ getTypeName(a) }}</span></b-card-text>
          </b-list-group-item>
        </draggable>
      </b-col>
      <!-- group 2 -->
      <b-col
        cols="12"
        md="6"
        class="mt-sm-2 mt-md-0"
      >
        <h6 class="my-4">
          Dostępne elementy
        </h6>
        <!-- draggable -->
        <draggable
          :list="trainingElements"
          tag="ul"
          group="trainingElements"
          class="list-group dragArea elements-area"
        >
          <b-list-group-item
            v-for="(t, index) in trainingElements"
            :key="index"
            tag="li"
          >
            <b-card-text class="mb-0 font-weight-bold move-cursor text-color-base">{{ t.name }} <span class="badge badge-info">{{ getTypeName(t) }}</span></b-card-text>
          </b-list-group-item>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import draggable from 'vuedraggable'
import {manageTrainingElements} from "@/mixins/trainings/trainingsMixin";


export default {
  name: 'TrainingElements',
  mixins: [manageTrainingElements],
  components: {
    draggable,
  },
  methods: {
    handleChange(event) {
      if(event.added){
        console.log(event.added.element.uuid)
        this.attachTrainingElement(event.added.element.uuid)
      }
      else if(event.removed){
        this.detachTrainingElement(event.removed.element.uuid)

      }
      else if(event.moved){
        this.orderTrainingElements()
      }
    },
    getTypeName(te) {
      if(te.type === 'App\\Models\\Lesson') return 'Lekcja'
      if(te.type === 'Expansja\\Ez\\Examination\\Exam') return 'Egzamin'
      return '';
    }
  }
}
</script>
<style lang="scss">
.move-cursor {
  cursor: move;
}
.elements-area {
  min-height: 40px;
  border: #d6d6d6 1px dashed;
}
</style>
